import Head from "next/head";
import { styled, Typography } from "@mui/material";
import { useRouter } from "next/router";
import NotFoundCode from "../../assets/svg/404.svg";
import { ThemeButton } from "./ThemeComponents/ThemeButton";
import { BackButton } from "./BackButton";
import CommonHead from "../../builder/CommonHead";
import ErrorPage from "./ErrorPage";
import { useTranslation } from "../../helpers/i18n";

const Container = styled("div")(() => ({
  height: "100%",
}));

const Main = styled("div")(() => ({
  display: "flex",
  height: "100%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const PageNotFound = styled(Typography)(() => ({
  marginBottom: "2rem",
  marginTop: "2rem",
  color: "black",
}));

const BackButtonContainer = styled("div")(() => ({
  position: "absolute",
  top: "3rem",
  left: "3rem",
}));

const NotFound = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const title = t("information_page_not_found");
  return (
    <ErrorPage pageType="notFound">
      <Container>
        <CommonHead titleSufix={title} />
        <Head>
          <meta name="robots" content="noindex, nofollow" />
        </Head>
        <Main>
          <BackButtonContainer>
            <BackButton onClick={() => router.back()} />
          </BackButtonContainer>
          <NotFoundCode alt="" aria-hidden="true" />
          <PageNotFound variant="h1">{title}</PageNotFound>
          <ThemeButton href="/">
            {t("information_back_to_marketplace_button")}
          </ThemeButton>
        </Main>
      </Container>
    </ErrorPage>
  );
};

export default NotFound;
